import { render, staticRenderFns } from "./Excluded.vue?vue&type=template&id=6df4faad&scoped=true&"
import script from "./Excluded.vue?vue&type=script&lang=js&"
export * from "./Excluded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df4faad",
  null
  
)

export default component.exports